import { createContext, useContext, useEffect, useState } from 'react';
import { api } from '@/lib/api';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [academy, setAcademy] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('locals_token');
        if (!token) {
            setLoading(false);
            return;
        }
        api.get('/auth/me')
            .then((r) => {
                setUser(r.data.user);
                setAcademy(r.data.academy);
            })
            .catch(() => {
                localStorage.removeItem('locals_token');
            })
            .finally(() => setLoading(false));
    }, []);

    const login = async (username, password) => {
        const r = await api.post('/auth/login', { username, password });
        localStorage.setItem('locals_token', r.data.token);
        setUser(r.data.user);
        setAcademy(r.data.academy);
        return r.data;
    };

    const logout = () => {
        localStorage.removeItem('locals_token');
        setUser(null);
        setAcademy(null);
    };

    return (
        <AuthCtx.Provider value={{ user, academy, loading, login, logout }}>
            {children}
        </AuthCtx.Provider>
    );
}

export const useAuth = () => useContext(AuthCtx);
